import { Box, Grid } from '@mui/material'
import { colors } from '@/theme/colors.theme'
import LoginComponent from './components/index.component'

import UiFeedbackComponent from './components/ui-feedback/index.component'
import bg from '../../assets/img/login-background.png'

const LoginModule = () => {
  return (
    <Grid
      container
      spacing={0}
      sx={{
        minHeight: '100vh',
        pl: 0,
        pt: 0,
        backgroundColor: colors.nav,
      }}
    >
      <Grid
        item
        xs={0}
        md={8}
        sx={{
          backgroundImage: `url(${bg})`,
          backgroundSize: 'cover',
          backgroundPositionX: 'center',
        }}
      >
        <Box
          sx={{
            background: colors.primary,
            opacity: 0.7,
            width: '100%',
            height: '100vh',
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <LoginComponent />
      </Grid>
      <UiFeedbackComponent />
    </Grid>
  )
}

export default LoginModule
